import {createAsyncThunk, createSlice} from "@reduxjs/toolkit";

import { REHYDRATE } from 'redux-persist/es/constants';
import paymentService from "./paymentService";

const initialState = {
    scheme: "bacs",
    currency: "GBP",
    country_code: "GB",

    authorisation_url: null,
    billing_requests_id: "",
    email: "",
    given_name: "",
    family_name: "",
    address_line1: "",
    city: "",
    postal_code: "",
    account_number: "",
    branch_code: "",
    account_holder_name: "",

    createBillingRequestIsPending: false,
    createBillingRequestIsSuccess: false,
    createBillingRequestIsError: false,

    initialiseBillingRequestIsPending: false,
    initialiseBillingRequestIsSuccess: false,
    initialiseBillingRequestIsError: false,

    collectCustomerDetailsisPending: false,
    collectCustomerDetailsisSuccess: false,
    collectCustomerDetailsisError: false,

    orderID: null,
}


export const sendCombined = createAsyncThunk(`send all combined`, async (data, thunkAPI) => {

        try {

            return await paymentService.sendCombined(data)
        } catch (error) {
            const paymentMessage =
                (error.response &&
                    error.response.data &&
                    error.response.data.message) ||
                error.message ||
                error.toString()
            return thunkAPI.rejectWithValue(paymentMessage)
        }
    }
)





export const paymentSlice = createSlice({
    name: "payment", //?
    initialState,
    reducers:{
        paymentReset: (state) => initialState,


        setPaymentDetails: (state, action) =>{
            state.description = action.payload.description
            state.amount = action.payload.amount
            state.app_fee = action.payload.app_fee
        },
        [REHYDRATE]: (state, action) => {
            return {
                ...state,
                ...action.payload,
            };
        }
    },
    extraReducers: (builder) =>{
        builder
            .addCase(sendCombined.fulfilled, (state, action) => {
                // console.log(action)
                state.orderID = action.payload.id
                state.authorisation_url = action.payload.order.payment_url
            })
            .addCase(sendCombined.rejected, (state, action) => {
                console.error('Error payload:', action.payload);
            })


    }

})

export const {

} = paymentSlice.actions;

export default paymentSlice.reducer;